import { Table } from "@/features/Table";
import { type A9Transaction, porfolios_columns } from "./columns";
import {
  type FilterA9TransactionsSchema,
  FilterA9Transactions,
} from "./filter";

const client = "a9";
const table_name = "a9_transactions";

export const A9TransactionsTable = () => {
  return (
    <Table<A9Transaction, FilterA9TransactionsSchema>
      label="Transactions"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterA9Transactions />}
      actions={[
        {
          label: "actions.new",
          route: `a9/${table_name}/new`,
        },
      ]}
    />
  );
};
